import { api, getToken } from "../auth-api/apiUrl";
import * as  endPoints from "../../../config/config";
import { findClientProps, findDomainProps, findSegmentProps, findSubSegmentProps, statusProps } from "../../../utils/types";

export function getClients(name : string) : Promise<findClientProps[]>{
    return new Promise(async(resolve, reject)=>{
        try{
            const client = await api.get(endPoints.FIND_CLIENTS_END_POINT+name, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            resolve(client.data);
        }catch(e){
            reject(e);
        }
    })
}

export function getDomains(name : string) : Promise<findDomainProps[]>{
    return new Promise(async(resolve, reject)=>{
        try{
            const domain = await api.get(endPoints.FIND_DOMAIN_END_POINT+name, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            resolve(domain.data);
        }catch(e){
            reject(e);
        }
    })
}

export function getSegments(name : string, id : number) : Promise<findSegmentProps[]>{
    return new Promise(async(resolve, reject)=>{
        try{
            const segment = await api.get(endPoints.FIND_SEGMENT_END_POINT+id+'/'+name, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            resolve(segment.data);
        }catch(e){
            reject(e);
        }
    })
}

export function getSubSegments(id : number) : Promise<findSubSegmentProps[]>{
    return new Promise(async(resolve, reject)=>{
        try{
            const sub_segment = await api.get(endPoints.FIND_SUB_SEGMENT_END_POINT+id, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            resolve(sub_segment.data);
        }catch(e){
            reject(e);
        }
    })
}

export function getJdlStatus() : Promise<statusProps[]>{
    return new Promise(async(resolve, reject)=>{
        try{
            const status = await api.get(endPoints.GET_JDL_STATUS_END_POINT, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            resolve(status.data);
        }catch(e){
            reject(e);
        }
    })
}